// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import LoginPage from './pages/Auth/LoginPage';
import SignupPage from './pages/Auth/SignupPage';
import Home from './pages/Home/HomePage';
import ProductListPage from './pages/Product/ProductListPage';
import CreateProductPage from './pages/Product/CreateProductPage';
import UsersListPage from './pages/Users/UsersListPage';
import CategoryPage from './pages/Category/CategoryPage';
import CreateCategoryPage from './pages/Category/CreateCategoryPage';
import CreateUserPage from './pages/Users/CreateUserPage';
import BidsPage from './pages/Bids/BidsPage';
import OrderPage from './pages/Orders/OrderPage';
import './App.css';
import { Provider } from 'react-redux';
import store, { persistor } from './utils/store';
import OrderDetails from './pages/Orders/OrderDetails';
import BidDetails from './pages/Bids/BidDetails';
import GeneralSettings from './pages/GeneralSettings/GeneralSettings';
import TokenChecker from './utils/TokenChecker';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="App">
          {/* Set basename for React Router */}
          <Router>
            <TokenChecker />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<SignupPage />} />
              <Route path="/products/list" element={<ProductListPage />} />
              <Route path="/products/create" element={<CreateProductPage />} />
              <Route path="/products/update/:productId" element={<CreateProductPage />} />
              <Route path="/users/list" element={<UsersListPage />} />
              <Route path="/users/create" element={<CreateUserPage />} />
              <Route path="/user-details/update/:userId" element={<CreateUserPage />} />
              <Route path="/categories/list" element={<CategoryPage />} />
              <Route path="/categories/create" element={<CreateCategoryPage />} />
              <Route path="/categories/update/:categoryId" element={<CreateCategoryPage />} />
              <Route path="/bids/list" element={<BidsPage />} />
              <Route path="/bid-details/:bidId" element={<BidDetails />} />
              <Route path="/orders/list" element={<OrderPage />} />
              <Route path="/generalSettings" element={<GeneralSettings />} />
              <Route path="/orders/view/:orderId" element={<OrderDetails />} />
            </Routes>
          </Router>
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;